export const ToastMessage = {
	PASS_RESET_SUCCESS: 'The password has been reset successfully!',
	SOMETHING_WENT_WRONG: 'Something went wrong',
};
